import {UISidebarController} from '../../../ui_html/new_layout/UISidebarController'
import {UIChampionship25Controller} from '../../../../../shared/scripts/ui_cc/UIChampionship25Controller'

export class UIDChampionship25SceneController {
    private readonly sidebarController: UISidebarController
    private readonly championship25SceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        new UIChampionship25Controller()
        this.championship25SceneContainerDiv = document.getElementById('scene_discord_championship25_container') as HTMLDivElement
    }

    hide() {
        this.championship25SceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.championship25SceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
